import { Component, Input, OnDestroy} from '@angular/core';
import {trigger,state,style,animate,transition} from '@angular/animations';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/services/message/message.service';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ConfigService } from 'aws-sdk';


@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  animations:[
    //used to target in html
    trigger('fadeAnimation', [

      state('show', style({opacity: 1, display:'block'})),

      state('hide', style({opacity: 0, display:'none'})),

      transition('* => show', [animate('1s')]),

      transition('show => hide', [animate('1s')])
    ])
  ]
})
export class NotificationComponent{

  @Input() displayTime: number = 2000;

  message: string = "";
  subscription: Subscription;
  isOpen = false;
  currentStyle = 'default';
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';


  constructor(private messageService: MessageService, private _snackBar: MatSnackBar) { 
    this.subscription = this.messageService.getNotificationSubject().subscribe(notification => {
      const config = new MatSnackBarConfig();
      config.panelClass = notification.style;
      config.duration = 4000;
      config.horizontalPosition = 'center';
      config.verticalPosition = 'top';
      this.displayMessage(notification, config);
    });
  }

  displayMessage(notification:any, config:MatSnackBarConfig){
    this._snackBar.open(notification.message, null, config)
  }

}
